import React from 'react';
import Layout from '../../components/Layout';
import WallpaperGallery from '../gallery/WallpaperGallery';
import HeadMessage from '../../components/Common/HeadMessage/HeadMessage';

async function action({ params, fetch }) {
	// Функция для загрузки страницы
	async function fetchPage(page) {
		const resp = await fetch('/graphql', {
			body: JSON.stringify({
				query: `{top(query:"${
					params.query ? params.query : ''
				}", p: ${page}){id,urlDownload,query,authorLink,authorName,urlFull}}`,
			}),
		});

		const { data } = await resp.json();
		return data.top;
	}

	const data = await fetchPage(1);
	if (!data) throw new Error('Failed to load the wallpaper.');

	const title = params.query
		? `${params.query} wallpapers for a new tab`
		: 'Top wallpapers for your new tab';

	return {
		chunks: ['top'],
		title,
		description: params.query
			? `Free ${params.query} wallpapers you can set as the background of your Chrome new tab page in one click.`
			: 'A gallery of free wallpapers you can set as the background of your Chrome new tab page in one click, from photography to animated backgrounds.',
		component: (
			<Layout>
				<HeadMessage>
					<h1>
						Top <span>images</span>
					</h1>
					<h5>{params.query}</h5>
				</HeadMessage>

				<WallpaperGallery
					guid=""
					images={data}
					fetch={fetch}
					fetchPage={fetchPage}
				/>
			</Layout>
		),
	};
}

export default action;
